import { Link } from "@tanstack/react-router";
import logoSrc from "@/assets/lel-logo.png";
const logo = { url: logoSrc };
import { footerGroups } from "@/lib/site-nav";

const linkClass = "text-sm text-muted-foreground transition-colors hover:text-primary";

export function SiteFooter() {
  return (
    <footer className="border-t border-border/60 bg-lavender">
      <div className="mx-auto max-w-7xl px-6 py-16">
        <div className="grid gap-12 lg:grid-cols-[1.2fr_2fr]">
          <div>
            <Link to="/" className="inline-flex items-center">
              <img src={logo.url} alt="Leadership Edge Live" className="h-10 w-auto" />
            </Link>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-muted-foreground">
              Leadership Edge Live helps organizations build confident, consistent leaders through
              live micro-learning, workplace application, and experienced development support.
            </p>
            <Link
              to="/contact/"
              className="mt-6 inline-flex items-center rounded-[6px] bg-[#693D94] px-5 py-2.5 text-sm font-semibold text-primary-foreground shadow-brand"
            >
              Talk to a Development Pro
            </Link>
          </div>
          <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
            {footerGroups.map((group) => (
              <div key={group.heading}>
                <h4 className="mb-4 font-sans text-xs font-semibold uppercase tracking-wider text-primary">
                  {group.heading}
                </h4>
                <ul className="space-y-2.5">
                  {group.kind === "problem"
                    ? group.items.map((item) => (
                        <li key={item.slug}>
                          <Link
                            to="/problems/$slug/"
                            params={{ slug: item.slug }}
                            className={linkClass}
                          >
                            {item.label}
                          </Link>
                        </li>
                      ))
                    : group.items.map((item) => (
                        <li key={item.to}>
                          <Link to={item.to} className={linkClass}>
                            {item.label}
                          </Link>
                        </li>
                      ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
        <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-border/60 pt-6 text-xs text-muted-foreground sm:flex-row">
          <p>© {new Date().getFullYear()} Leadership Edge Live. All rights reserved.</p>
          <div className="flex gap-4">
            <Link to="/privacy-policy/" className="hover:text-primary">
              Privacy Policy
            </Link>
            <Link to="/terms-and-conditions/" className="hover:text-primary">
              Terms and Conditions
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
